import { render, staticRenderFns } from "./CaracteristicasPlan.vue?vue&type=template&id=f919e7e2"
import script from "./CaracteristicasPlan.vue?vue&type=script&lang=js"
export * from "./CaracteristicasPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports